import { Button } from '@material-ui/core';
import SaveAltIcon from '@material-ui/icons/SaveAlt';
import NotificationProvider from 'components/NotificationProvider';
import { useExportSingleAssetCostReportMutation } from 'features/vehicles/vehicleSlice';
import { useState } from 'react';
import CostReportExportModal from './CostReportExportModal';
import { useCostReportExportModalStyles } from './CostReportExportModalStyles';

// SCN-402 — Export button on the asset detail page.
const SingleAssetCostReportExport = ({ vehicleDetails }) => {
    const classes = useCostReportExportModalStyles();
    const [open, setOpen] = useState(false);

    const [exportCostReport, { isLoading: isExporting }] = useExportSingleAssetCostReportMutation();

    const handleExport = async ({ dateStart, dateEnd, categories }) => {
        const result = await exportCostReport({
            vehicleId: vehicleDetails?.id,
            descriptor: vehicleDetails?.descriptor,
            dateStart,
            dateEnd,
            categories,
        });

        if (result?.error) {
            NotificationProvider.error('Failed to export cost report');
            return;
        }

        setOpen(false);
    };

    return (
        <>
            <Button
                variant="outlined"
                color="primary"
                size="large"
                startIcon={<SaveAltIcon />}
                className={classes.exportTriggerButton}
                onClick={() => setOpen(true)}
            >
                Cost Report
            </Button>
            <CostReportExportModal
                open={open}
                onClose={() => setOpen(false)}
                onExport={handleExport}
                isExporting={isExporting}
            />
        </>
    );
};

export default SingleAssetCostReportExport;
